const state = {
  //敏感词数组
  SensitiveWordsArray: null
}

const getters = {
  SensitiveWordsArray(state) {
    return state.SensitiveWordsArray || sessionStorage.getItem("SensitiveWordsArray")
  },
}

const mutations = {
  SAVE_SensitiveWordsArray(state, value) {
    state.SensitiveWordsArray = value;
    sessionStorage.setItem("SensitiveWordsArray", value);
  },
  REMOVE_SensitiveWordsArray(state) {
    state.SensitiveWordsArray = null;
    sessionStorage.removeItem('SensitiveWordsArray')
  },
}

const actions = {
  saveSensitiveWordsArray(context, value) {
    context.commit('SAVE_SensitiveWordsArray', value)
  },

  removeSensitiveWordsArray(context) {
    context.commit('REMOVE_SensitiveWordsArray')
  },

  removeAll(context) {
    context.commit('REMOVE_SensitiveWordsArray')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/js/store/modules/systemSetting.js